import { REST, Args, Models } from 'fluent-forever-shared-types';
import { ApiConfig as CONFIG_API } from "config/config";
import { IHttpRequest } from 'application/utils';

/** Validate Coupon/Backer Code */
export const validate = (request: IHttpRequest, body: Args.IValidateCouponCodeArg): Promise<Models.ICouponCodeInfo> => {
    return request.post(CONFIG_API.url + REST.PATH.COUPON_CODE_VALIDATE, body)
        .then(rst => rst.data);
}

/** Submit Coupon Code */
export const redeem = (request: IHttpRequest, body: Args.IRedeemCouponCodeArg): Promise<Models.ICouponCodeRedemptionResult> => {
    return request.post(CONFIG_API.url + REST.PATH.COUPON_CODE_REDEEM, body)
        .then(rst => rst.data);
}


// WEBPACK FOOTER //
// ./src/api/couponCode.ts